import { CircularProgress } from '@mui/material';
import { SizeLoading } from 'enums';

export interface CircleLoadingProps {
    size?: SizeLoading;
}

const CircleLoading = ({ size }: CircleLoadingProps) => {
    const getSize = (s?: SizeLoading) => {
        switch (s) {
            case SizeLoading.SMALL:
                return 16;
            case SizeLoading.MIDDLE:
                return 24;
            case SizeLoading.LARGE:
                return 32;
            default:
                return 24;
        }
    };
    return (
        <CircularProgress size={getSize(size)} sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(50%, -50%)' }} />
    );
};

export default CircleLoading;
